import * as React from "react";
import {
  Column,
  TableCellRenderer,
  CellInfo
} from "react-table";
import _ from "lodash";
import { $enum } from "ts-enum-util";

import { CustomTableColumn } from "src/library/components/Tables/Table";
import { Select } from "src/library/components/Forms";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { SubstitutionStatus } from "src/modules/substitutions/components/SubstitutionStatus";
import { ProductSubstitutionStatus } from "src/modules/substitutions/api/substitutions.api";

/**
 * Subs status column
 */
export const substitutionStatus = (): CustomTableColumn => {
  return {
    Header: "Status",
    accessor: "status",
    width: 200,
    Filter: ({ onChange, filter }) => {
      return (
        <Select
          value={filter ? filter.value : ""}
          label=""
          as="select"
          name="status"
          unselectedOption={{
            text: "Please Select",
            value: ""
          }}
          handleChange={e => onChange(e.target.value)}
          options={_.map($enum(ProductSubstitutionStatus).getValues(), status => ({
            text: status,
            value: status,
            checked: filter && filter.value === status
          }))}
        />
      );
    },

    Cell: (cellProps: CellInfo) => <SubstitutionStatus status={cellProps.value} />
  };
};

export const productSubstitutionTableColumns = (ActionButton: TableCellRenderer): Column[] => [
  globalTableColumns.standardText({
    Header: "Product",
    accessor: "previousProduct.description",
    width: 220
  }),
  globalTableColumns.date({
    header: "Start date",
    accessor: "startDate",
    format: "DD/MM/YYYY",
    width: 100
  }),
  globalTableColumns.date({
    header: "End date",
    accessor: "endDate",
    format: "DD/MM/YYYY",
    width: 100,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Reason code",
    accessor: "reasonCode.code",
    width: 140
  }),
  substitutionStatus(),
  globalTableColumns.standardText({
    Header: "Reason message",
    accessor: "message",
    width: 500
  }),
  globalTableColumns.actions({ cell: ActionButton })
];
